import { Profile, UNAVAILABLE_CS_FIRM } from '@constants';

const { CUSTOMER_SERVICE, STRATEGIC_CONSULTING, ATLAS, TIMBERLINE } = Profile;

/* 
    Firms as they returned from the backend after being formatted by the get-client utility method:

    Newport Legal Group
    Spring Legal Group
    Guidestone Law Group
    Greenstone Legal Group
    Hallock & Associates LLC
    White Oak Law Group
    Northstar Legal Group   
    Royal Legal Group
    Great Lakes Law Firm
    Stonepoint Legal Group
    Timberline Financial
    Atlas Debt Relief
    Meadowbrook Legal Group
    Infinite Law Group
*/

export const getFirmShortName = (firm: string) => {
    const legalTerms = ['legal', 'group', 'law', 'financial', '2', 'firm', 'llc', 'debt', 'relief'];

    return firm ? firm
            .toLowerCase()
            .split(' ')
            .filter(word => !legalTerms.includes(word))
            .map(word => word === '&' ? word :  word.charAt(0).toUpperCase() + word.substring(1))
            .join(' ') : null;
};

export function getCopyrightProfile(locationStateProfile: string, clientFirm: string) {
    if (locationStateProfile === 'Customer Service') {
        return 'Strategic Financial Solutions';
    }

    return getProfile(clientFirm);
}   

export function getProfile(firm: string) {
    const firmShortName = getFirmShortName(firm);

    if (!firmShortName) {
        return 'Strategic Consulting';
    } else {
        return isAttorneyProfile(firmShortName) ? 'Strategic Consulting' : 'Atlas';
    }
}

export function getProfileNameForLogo(firmShortName: string | null, profile: Profile | null) {
    const creditAnalysisInfoExists = firmShortName !== UNAVAILABLE_CS_FIRM;

    if (firmShortName === ATLAS || firmShortName === TIMBERLINE) {
        return firmShortName;
    } else if (profile === CUSTOMER_SERVICE && !creditAnalysisInfoExists) {
        return 'Strategic Financial Solutions';
    }

    return STRATEGIC_CONSULTING;
}

export function isAttorneyProfile(profile: string | null) {
    const { ATLAS, TIMBERLINE } = Profile;

    if (profile === ATLAS || profile === TIMBERLINE) {
        return false;
    }

    return true;
}

export function getProfileOptions(profile: string): string[] {
    const { ADMIN, CUSTOMER_SERVICE, SALES, TESTING } = Profile;

    switch(profile) {
        case ADMIN:
            return [ADMIN, TESTING, CUSTOMER_SERVICE, SALES ];
        case CUSTOMER_SERVICE:
            return [CUSTOMER_SERVICE];
        default:
            return [SALES];
    }
}

export function getSlideTranslationKey(name: string) {
    return name ? name.toLowerCase().split(' ').join('_') : null;
}
